import { Tooltip } from 'antd';

import infoIcon from '../../../assets/ImageCreation/info.svg';
import { LocalImage } from '../../Image';

export const Title = ({
  title,
  desc,
  styles,
}: {
  title: string;
  desc?: string;
  styles: Record<string, string>;
}) => {
  return (
    <p className={styles.title}>
      {title}
      {desc && (
        <Tooltip
          title={
            <div className={styles.modelDesc}>
              <p>{desc}</p>
            </div>
          }
          color="#282A2E"
          placement="right"
          overlayInnerStyle={{
            maxWidth: '240px',
            whiteSpace: 'wrap',
            color: 'rgba(255, 255, 255, 0.75)',
          }}
        >
          <LocalImage className={styles.icon} src={infoIcon} />
        </Tooltip>
      )}
    </p>
  );
};
